import { featureFlagsStore } from '../stores/featureFlagStore';
export const FeatureFlags = {
  get HIDE_TRIAL_TEMPLATES_TAB() {
    return withLocalStorageOverride('FF_HIDE_TRIAL_TEMPLATES_TAB', isEnabled('partner_hide_trial_templates_tab', false));
  },
  get SHOW_ANALYTICS_EXPORT_PAGE() {
    return withLocalStorageOverride('FF_SHOW_ANALYTICS_EXPORT_PAGE', isEnabled('partner_show_analytics_export_page', false));
  },
  get ANALYTICS_CHARTS() {
    return withLocalStorageOverride('FF_ANALYTICS_CHARTS', isEnabled('partner_show_analytics_dashboard', false));
  },
  get AGENTFORCE_INFO_LISTINGS() {
    return withLocalStorageOverride('FF_AGENTFORCE_INFO_LISTINGS', isEnabled('partner-agentforce-info-listings', false));
  },
  get AGENTFORCE_SPECIFIC_FIELDS_UI_ACTIVATION() {
    return withLocalStorageOverride('FF_AGENTFORCE_SPECIFIC_FIELDS_UI_ACTIVATION', isEnabled('partner-AgentForce-specific-fields-UI-activation', false));
  }
};
function isEnabled(featureFlag, defaultValue = false) {
  var _featureFlagsStore$ge;
  return (_featureFlagsStore$ge = featureFlagsStore.getState().featureFlags[featureFlag]) !== null && _featureFlagsStore$ge !== void 0 ? _featureFlagsStore$ge : defaultValue;
}
function withLocalStorageOverride(featureFlagName, defaultValue = false) {
  var _globalThis$localStor, _globalThis$localStor2;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const override = (_globalThis$localStor = (_globalThis$localStor2 = globalThis.localStorage) === null || _globalThis$localStor2 === void 0 ? void 0 : _globalThis$localStor2.getItem(featureFlagName)) !== null && _globalThis$localStor !== void 0 ? _globalThis$localStor : null;
  if (override == null) {
    return defaultValue;
  }
  return override === 'true';
}